import { SET_CURRENT_USER, LOGIN_ERROR, SIGN_USER_OUT } from "../actions/actionTypes"


const initialState={
  isAuthenticated: false,
  user: {},
  loginErrorMsg: '',
}


export default function(state=initialState, action){
  switch(action.type){
    case SET_CURRENT_USER:
      return{
        ...state,
        user: action.payload,
        isAuthenticated: true,
        loginErrorMsg: ''
      }

    case LOGIN_ERROR:
      return{
        ...state, 
        loginErrorMsg: action.payload
      }

    case SIGN_USER_OUT:
      return{
        ...state,
        isAuthenticated: false,
        user: {},
        loginErrorMsg: ''
      }

    default:
    return state
  }
}